<div [class.active-options]="showOptions" class="filter-container relative">
  <mat-chip disableRipple>
    <span class="sparro-grey-800">{{ placeholder }}: <span class="sparro-grey-900 margin-x-2">{{ chosenOption }}</span></span>
    <i class="icon-edit-bold cursor-pointer sparro-grey-800" (click)="toggleShowOptions()"></i>
  </mat-chip>

  <div class="option-container" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="padding-left-3 padding-right-1 padding-y-2">
      <span class="font-bold">Select a date range</span>
      <button mat-icon-button class="icon-cross-bold cursor-pointer font-md" (click)="toggleShowOptions()"></button>
    </div>

    <div fxLayout="column" fxLayoutGap="24px" class="padding-x-3">
      <mat-radio-button [checked]="selectedOption === option" *ngFor="let option of filterOptions.concat(extraOptions)" (click)="setSelectedOption(option)" [value]="option">
          {{ option }}
      </mat-radio-button>
      <mat-radio-button [checked]="selectedOption === 'Custom'" (click)="setSelectedOption('Custom')" value="Custom"> Custom </mat-radio-button>
    </div>
    
    <div *ngIf="selectedOption === 'Custom'" fxLayout="row" fxLayoutGap="16px" class="padding-x-3">
      <mat-form-field>
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="pickerFrom" (dateChange)="setCustomDate('startDate', $event)" [max]="currentDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerFrom">
          <mat-icon matDatepickerToggleIcon class="margin-0">
            <uni-image [src]="calenderIconSvg" alt="calender-icon" [height]="20" [width]="20" classes="fit-cover"></uni-image>
          </mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #pickerFrom startView="year"></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="pickerTo" [min]="startDate" [max]="currentDate" (dateChange)="setCustomDate('endDate', $event)" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerTo">
          <mat-icon matDatepickerToggleIcon>
            <uni-image [src]="calenderIconSvg" alt="calender-icon" [height]="20" [width]="20" classes="fit-cover"></uni-image>
          </mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #pickerTo startView="year"></mat-datepicker>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" class="padding-3">
      <uni-navigation-button
        default="Cancel"
        button_class="secondary"
        (click)="toggleShowOptions()">
      </uni-navigation-button>
      <uni-navigation-button
        default="Apply"
        button_class="primary"
        (click)="onSubmit()"
        [disabled]="extraOptions.includes(selectedOption) ? false : !(startDate && endDate)">
      </uni-navigation-button>
    </div>
  </div>
</div>
